import { observer } from 'mobx-react';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../../core/utils/hook';

import '../style.scss';
import { DATE_YMD } from '../../../core/configs/constants';

const NotifyList = observer(props => {

    // navigate
    const navigate = useNavigate();

    // store
    const { notifyStore: { notifies, getNotifies, cleanNotifiesPaging } } = useStore();

    // lifecycle
    useEffect(() => {
        getNotifies({ size: -1, status: 1 });
        return () => {
            cleanNotifiesPaging();
        }
    }, [])

    return(
        <div className='notify container'>
            <div className='heading'>【お知らせ】</div>
            {/* {
                notifies?.length > 0 ?
                    <div className='list-notify'>
                        {
                            notifies?.map((e, index) => 
                                <React.Fragment key={e.id}>
                                    <div className='notify-content' onClick={() => navigate(`notification/${e.id}`)}>
                                        <span className='notify-date'>{moment(e.createdAt).format(DATE_YMD)}</span>
                                        <span className='notify-title'>{e.title}</span>
                                    </div>
                                    <div className='border-bottom'></div>
                                </React.Fragment>
                            )
                        }
                    </div>
                    :
                    <div className='mg-t-10'>お知らせがありません。</div>
            } */}
            {
                notifies?.length > 0 ? (
                    <div className='content cursor-pointer' onClick={() => navigate(`/notification/${notifies[0].id}`)}>
                        <div className='public-date'>{moment(notifies[0].releaseDate).format(DATE_YMD)}</div>
                        <div className='title line-clamp-1'>{notifies[0].title}</div>
                    </div>
                ) : <div className='content'>
                    <div className='title'>お知らせがありません。</div>
                </div>
            }
        </div>
    )
})

export default NotifyList;